import React, { useState, useEffect } from 'react';

const PageLoader = ({ isLoading }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (isLoading) {
      setProgress(0);
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + 5;
        });
      }, 30);

      return () => clearInterval(interval);
    } else {
      setProgress(0);
    }
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-6">
        {/* Logo */}
        <div className="relative">
          <img 
            src="/palla.avif" 
            alt="ZEUS SIRH" 
            className="h-24 w-24 object-contain animate-pulse"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="h-24 w-24 rounded-full border-4 border-blue-500 border-t-transparent animate-spin"></div>
          </div>
        </div>

        {/* Progress bar */}
        <div className="w-64">
          <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
            <div 
              className="h-full bg-gradient-to-r from-blue-500 to-blue-600 transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="mt-2 text-center text-sm text-gray-600">
            Chargement... {progress}%
          </p>
        </div>

        {/* Loading text */}
        <p className="text-lg font-medium text-gray-800">
          ZEUS SIRH
        </p>
      </div>
    </div>
  );
};

export default PageLoader;
